import { createStore } from 'vuex'

export default createStore({
  state: {
    loaderstate: false,
    login: {},
    lastlogin: false,
    settings: [],
    alertcounts: null,
    translations: null,
    dashboardusers: null
  },
  getters: {
    get_loaderstate: state => { return state.loaderstate; },
    get_login: state => { return state.login; },
    get_lastlogin: state => { return state.lastlogin; },
    get_settings: state => { return state.settings; },
    get_alertcounts: state => { return state.alertcounts; },
    get_translations: state => { return state.translations; },
    get_dashboardusers: state => { return state.dashboardusers; }
  },
  mutations: {
    SET_LOADERSTATE(state, val) { state.loaderstate = val; },
    SET_LOGIN(state, val) { state.login = val; },
    SET_LASTLOGIN(state, val) { state.lastlogin = val; },
    SET_SETTINGS(state, val) { state.settings = val; },
    SET_ALERTCOUNTS(state, val) { state.alertcounts = val; },
    SET_TRANSLATIONS(state, val) { state.translations = val; },
    SET_DASHBOARDUSERS(state, val) { state.dashboardusers = val; }
  },
  actions: {
    set_loaderstate({ commit }, val) { commit('SET_LOADERSTATE', val); },
    set_login({ commit }, val) { commit('SET_LOGIN', val); },
    set_lastlogin({ commit }, val) { commit('SET_LASTLOGIN', val); },
    set_settings({ commit }, val) { commit('SET_SETTINGS', val); },
    set_alertcounts({ commit }, val) { commit('SET_ALERTCOUNTS', val); },
    set_translations({ commit }, val) { commit('SET_TRANSLATIONS', val); },
    set_dashboardusers({ commit }, val) { commit('SET_DASHBOARDUSERS', val); }
  }
})